
<div class="dashboard-container">
  <div class="border-0 ">
        <p class="fw-bold">Select A Programme For System Configuration</p>
        <div class="glassy-bg rounded-lg">
          <GlobalTable
            :headers="table_headers"
            :data="table_safe_company_list"
            table_id="company_management_table"
          >
            <template #actions="{ row }">
              <div class="form-check form-switch d-flex justify-content-center">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="'config_switch_' + row.id"
                  :checked="isSelectedProject(row.id)"
                  @change="toggle_config_project(row)"
                >
                <label
                  class="form-check-label ms-2 text-xxs"
                  :for="'config_switch_' + row.id"
                >
                  {{ isSelectedProject(row.id) ? 'Active' : 'Select' }}
                </label>
              </div>
            </template>
          </GlobalTable>

    </div>
  </div>

  <!-- Footer -->
  <AICampusFooter/>
</div>

